import { render, staticRenderFns } from "./SuccessRegisterModalForInvitedUser.vue?vue&type=template&id=40ebcdcc"
import script from "./SuccessRegisterModalForInvitedUser.vue?vue&type=script&lang=js"
export * from "./SuccessRegisterModalForInvitedUser.vue?vue&type=script&lang=js"
import style0 from "./SuccessRegisterModalForInvitedUser.vue?vue&type=style&index=0&id=40ebcdcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports